<div class="bar-container-container">
    <fade-in-and-out [isVisible]="isVisible" maxHeight="150px" transform="translateY(150px)">
        <div class="bar-container">
            <div class="bar" role="status">
                <span class="message">{{texts.message}}</span>
                <span class="actions">
                    <button mat-raised-button color="accent" (click)="switchLanguage()">{{texts.switchLabel}}</button>
                    <button mat-icon-button class="dismiss" [attr.aria-label]="texts.dismissLabel"
                        [title]="texts.dismissLabel" (click)="dismiss()">
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </div>
        </div>
    </fade-in-and-out>
</div>
